module.exports = "//static.hsappstatic.net/LoginUI/static-1.16032/img/connect.com-full-logo-color.svg"